// import { Permissions } from "constants/users/permissions";
import {
  PieChartOutlined,
  UserOutlined,
  ToolOutlined,
  LineChartOutlined,
  ReadOutlined,
  LayoutOutlined,
  ProfileOutlined,
  SettingOutlined,
  CloudServerOutlined,
  FormatPainterOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { PrivateUIRoutes } from "../../router";

export default function getLeftMenuData(): any[] {
  return [
    {
      id: 0,
      title: "Dashboard",
      key: "dashboard",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.DASHBOARD}`,
      Icon: PieChartOutlined,
    },
    {
      id: 7,
      title: "Engine",
      key: "engine",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.ENGINE_APP}`,
      Icon: CloudServerOutlined,
    },
    {
      id: 1,
      title: "Users",
      key: "users",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.USERS}`,
      Icon: UserOutlined,
    },
    {
      
      id: 11,
      title: "Indices",
      key: "Indices",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.INDICES}`,
      Icon: LineChartOutlined,
    },
    {
      
      id: 2,
      title: "Instruments",
      key: "instruments",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.INSTRUMENTS}`,
      Icon: ToolOutlined,
    },
    {
      id: 3,
      title: "News",
      key: "news",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.NEWS}`,
      Icon: ReadOutlined,
    },
    {
      id: 4,
      title: "Blog",
      key: "blog",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.BLOG}`,
      Icon: ProfileOutlined,
    },
    {
      id: 5,
      title: "Content Pages",
      key: "content",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.MAGIC_PAGES}`,
      Icon: LayoutOutlined,
    },
    {
      id: 6,
      title: "System Settings",
      key: "settings",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.SYSTEM_SETTINGS}`,
      Icon: SettingOutlined,
    },
    {
      id: 8,
      title: "Email Templates",
      key: "templates",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.EMAIL_TEMPLATES}`,
      Icon: FormatPainterOutlined,
    },
    {
      id: 9,
      title: "Subscribes",
      key: "subscribes",
      url: `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.SUBSCRIBES}`,
      Icon: UsergroupAddOutlined,
    },
  ];
}
